import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Typography,TextField, Box, Dialog, makeStyles, withStyles, Button, Theme, createStyles, DialogContent, Grid } from '@material-ui/core';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import { Loading } from '../commonLoadings';
import Config from "../../../config/config";
import { loadStripe } from '@stripe/stripe-js/pure';
import { getBillingDetails, notificationFail, setLoading, getStripeCustomerDetail } from "../../../store/actions/admin/user";
import { useSelector, useDispatch } from 'react-redux';
import moment from 'moment';
import axios from 'axios'
import CloseIcon from '@material-ui/icons/Close';
import CustomSnackBar from '../../pages/creator/experienceManager/participantsDashboard/component/CustomSnackBar';
import {
    CardElement,
    Elements,
    useStripe,
    useElements,
} from '@stripe/react-stripe-js';
import CreditCardTwoToneIcon from '@material-ui/icons/CreditCardTwoTone';
import UtilService from "../../../helper/service";
import {setIsUserVerication} from "../../../store/actions/auth/auth";
const styles = (theme: Theme) =>
    createStyles({
        root: {
        },
        modalHeader: {
          paddingTop: theme.spacing(2),
          paddingBottom: theme.spacing(1),
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        },
        closeButton: {
          color: theme.palette.grey[500],
          fontFamily: 'roboto-bold',
        },
        closeBtnIcon: {
          color: '#212D4080',
          width: 24,
          height: 24,
          fontFamily: 'roboto-bold'
        },
        modaltitle: {
          fontFamily: 'roboto-bold',
          fontSize: 18,
          color: '#212D40',
          textAlign: 'left'
        }
    });
const auth_token = localStorage.getItem("auth_token")
const idToken = localStorage.getItem("idToken")
const useStyles = makeStyles(() => ({
    root: {},
    paper: {
        borderRadius: '10px !important'
    },
    btn: {
        fontFamily: 'roboto-regular',
        textTransform:"initial"
    },
    cancelBtn: {
        margin: '0 15px',
        height: 37,
        borderRadius: 6,
        textTransform: 'none',
        fontSize: 14,
        color: '#697683',
    },
    contentText: {
        marginTop: '12px',
        fontFamily: 'roboto-regular',
    },
    cardholderName: {
        top: '497px',
        left: '347px',
        width: '70px',
        height: '16px',
        textAlign: 'left',
        letterSpacing: '-0.21px',
        color: '#8F99A3',
        opacity: 1,
        fontFamily: 'roboto-regular',
    },
    label: {
        "&$focusedLabel": {
            fontSize: 12,
            fontFamily: 'roboto-bold',
            color: "#606B76"
        },
        "&$erroredLabel": {
            color: "#707070"
        }
    },
    focusedLabel: {},
    erroredLabel: {},
    underline: {
        fontSize: 14,
        fontFamily: 'roboto-regular',
        color: '#697683',
        "&$error:after": {
            borderBottomColor: "#017AEF"
        },
        "&:after": {
            borderBottom: `3px solid #017AEF`
        }
    },
    error: {},
    cardDetails: {
        background: '#F0F0F0',
        padding: '35px',
        minHeight: '299px',
        height: '100%'
    },
    billingDetails: {
        padding:35
    },
    subdesc: {
        fontSize: '12px',
        fontWeight: 'bold',
        color: '#606b76',
        display: 'block',
        marginBottom: '10px',
    },
    desc: {
        fontSize: '20px',
        fontFamily: 'Spartan-bold',
        margin:0
    },
    price: {
        fontSize: '48px',
        fontFamily: 'Spartan-bold',
        margin: 10,
    },
    pricewrapper: {
        textAlign: 'center'
    },
    textLight: {
        fontSize: '16px',
        fontFamily: 'roboto-regular',
        color: '#606B76',
        letterSpacing: '0.4px'
    },
    textLightSmall: {
        fontSize: '16px',
        fontFamily: 'roboto-regular',
        color: '#606B76',
        letterSpacing: '0.4px'
    },
    priceDateWrapper: {
        marginTop: 50,
        textAlign: 'center'
    },
    descDate: {
        fontSize: '24px',
        fontFamily: 'Spartan-bold',
    },
    cardName: {
        marginTop: 50,
    },
    linkText: {
        color: '#017aef',
        cursor: 'pointer',
        fontSize: '12px',
        fontFamily: 'roboto-regular',
    },
    description: {
        fontSize: '14px',
    },
    addLicenseModal:{
        "& .totalAmt":{
          marginBottom: "9px",
          "& strong":{
            display: "block",
            color: "#606B76",
            fontSize: "12px",
            marginBottom: "17px",
          },
          "& p":{
            color: "#212D40",
            fontSize: "48px",
            fontFamily: "Spartan-bold",
            margin: 0,
          }
        },
        "& .perMonthUser":{
          "& strong":{
            display: "block",
            color: "#606B76",
            fontSize: "16px",
            fontWeight: 400,
            marginBottom: "5px",
          },
          "& p":{
            color: "#606B76",
            fontSize: "10px",
            textTransform: "uppercase",
            margin: 0,
          }
        },
        "& .subDate":{
          "& strong":{
            display: "block",
            color: "#606B76",
            fontSize: "12px",
            marginBottom: "12px",
          },
          "& p":{
            color: "#212D40",
            fontSize: "24px",
            fontFamily: "Spartan-bold",
            margin: 0,
          }
        }
    }
}));

const DialogTitle = withStyles(styles)((props: any) => {
    const { children, classes, onClose, ...other } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.modalHeader} {...other}>
          <Typography variant="h5" className={classes.modaltitle}>{children}</Typography>
          {onClose ? (
            <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
              <CloseIcon classes={{ root: classes.closeBtnIcon }} />
            </IconButton>
          ) : null}
        </MuiDialogTitle>
    );
});

AddUserLicences.propTypes = {
    onClose: PropTypes.func,
    open: PropTypes.bool.isRequired,
    departmentData: PropTypes.object,
    selectedPlan: PropTypes.any,
    openCloseSuccessModal: PropTypes.func,
    stripe_mode: PropTypes.any,
};



AddUserLicences.defaultProps = {
    onClose: () => {}
};
let subProrate: any = "";
const CheckoutForm = (props: any) => {
    const { closeModal, departmentData, selectedPlan, openCloseSuccessModal } = props;
    
    let remainingMonth = 0
    const endDate = moment(departmentData.pay_started_at*1000).add('days', Number(departmentData.billing_period?departmentData.billing_period:0)).format("MM/DD/YYYY")
    remainingMonth = Math.round(moment(endDate).diff(moment().format("MM/DD/YYYY"), 'months',true)*10)/10;
    
    const { loading } = useSelector((state: any) => state.adminUser);
    const [cardholderName, setcardholderName] = useState('');
    const [numberOfmember, setnumberOfmember] = useState(0);
    const [subscriptionDate, setSubscriptionDate] = useState < any > ();
    const dispatch = useDispatch();
    const classes = useStyles();
    const stripe: any = useStripe();
    
    const elements: any = useElements();
    const loginUserData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || '{}') : "";
    const apolloClient = useSelector((state: any) => state.apolloClient);
    const { stripeProductDetail, stripeCustomerDetail } = useSelector((state: any) => state.adminUser);
    const [snackAlertType, handleSnackAlertType] = useState('');
    const [snackAlertMsg, handleSnackMsg] = useState('');
    const [isShownSnackAlert, setShownSnackAlert] = useState(false);
    const [showCustomerDetails, setshowCustomerDetails] = useState < any > ('');
    const [isLoadingProrate, setisLoadingProrate] = useState(true);
    const [displayProrateAmount, setdisplayProrateAmount] = useState<any>('');
    // Create our number formatter.
    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    });

    function showSnackAlert(msg: string, type: string) {
        handleSnackMsg(msg);
        handleSnackAlertType(type);
        setShownSnackAlert(true);
    }

    function hideSnackAlert() {
        setShownSnackAlert(false);
    }
    useEffect(() => {
        if (stripeCustomerDetail) {
            setshowCustomerDetails(stripeCustomerDetail)
        }
    }, [stripeCustomerDetail])
    const [selectedProduct, setSelectedProduct] = useState < any > ();
    const [selectedSubscription, setSelectedSubscription] = useState < any > ();
    useEffect(() => {
        if (departmentData) {
            setnumberOfmember(departmentData.active_users_count)
            const currentPayStartedAt = departmentData.pay_started_at ? moment(Number(departmentData.pay_started_at) * 1000).format("MM/DD/YYYY hh:mm ") : "-"
            const checkValidDate = moment(currentPayStartedAt);

            let billingCycleDate = moment().unix();
            if (checkValidDate.isValid()) {
                const daysToAdd = Number(departmentData.billing_period ? departmentData.billing_period : 0) + 1 // adding 1 day to start subscription after end date
                const endDate = moment(Number(departmentData.pay_started_at) * 1000).add(daysToAdd, 'days').format("MM/DD/YYYY")
                const payDateForDiff = moment().format("MM/DD/YYYY");
                const endDateForDiff = moment(endDate, "MM/DD/YYYY");

                const daysLeft = endDateForDiff.diff(payDateForDiff, 'days')
                if (daysLeft > 0) { //future date
                    billingCycleDate = moment(endDateForDiff).unix();
                }
            }
            const date = moment(billingCycleDate * 1000).format("MMMM DD, yyyy")
            setSubscriptionDate(date)
        }
        if (stripeProductDetail.products.length && stripeProductDetail.plans.length) {
            stripeProductDetail.products.map((p: any, i: any) => {
                const plans = stripeProductDetail.plans.filter((ele: any) => ele.product === p.id)
                if (plans.length) {
                    stripeProductDetail.products[i].stripePrice = plans.length ? plans[0].amount : 0
                    stripeProductDetail.products[i].displayPrice = stripeProductDetail.products[i].stripePrice / 100
                    stripeProductDetail.products[i].price_id = plans[0].id
                    stripeProductDetail.products[i].plan_id = plans[0].id
                    stripeProductDetail.products[i].currency = plans[0].currency
                } else {
                    delete stripeProductDetail.products[i];
                }
            })
        }
        const filtered = stripeProductDetail.products.filter(function(obj: any) {
            if (obj.name.toLowerCase().indexOf(selectedPlan) !== -1) {
                return obj
            }
        });
        if (filtered.length > 0) {
            setSelectedProduct(filtered[0])
        }
        if(showCustomerDetails && stripeCustomerDetail.subscriptionsList && stripeCustomerDetail.subscriptionsList.length){
            const filteredSub = stripeCustomerDetail.subscriptionsList.filter(function(obj: any) {
                if (obj.id === departmentData.stripe_subscription_id && obj.status ==="active") {
                    return obj
                }
            });
            if(filteredSub.length > 0){
                setSelectedSubscription(filteredSub[0])
                subProrate = filteredSub[0]
                getProrationAmount(departmentData.active_users_count)
            }
        }
    }, [departmentData, stripeProductDetail,showCustomerDetails]);

    const validateEmail = (mail: any) => {
        if (/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(mail.trim())) {
            return (true)
        }
        return (false)
    }

    const makePayment = async () => {
        doProration()
    };

    const getProrationAmount = async (number:any) => {
        setisLoadingProrate(true)
        if(!loginUserData.customer_name){
            dispatch(notificationFail({},"Unable to get customer name of this user"));
            return
          }
          const obj = {
            customer_name:loginUserData.customer_name,
            display_name:loginUserData.customer_display_name,
            customer_id:loginUserData.customer_id,
          }
          departmentData.customers = obj
          

        //validate department as email
        if (!validateEmail(departmentData.department_name)) {
            dispatch(notificationFail({}, "Department name is not a valid email"))
            setisLoadingProrate(false)
            return
        }
        if (!subProrate) {
            dispatch(notificationFail({}, "You don't have any active subscription."))
            setisLoadingProrate(false)
            return
        }

        const numberOfmemberTemp:any = number


        if(!parseInt(numberOfmemberTemp) || parseInt(numberOfmemberTemp) < 0){
          dispatch(notificationFail({}, "Please enter user licenses more then zero"))
          setisLoadingProrate(false)
          return
        }

        const data = {
            selectedSubscription: subProrate,
            department_data: departmentData,
            numberOfmember: number,
            type:"memberProrate"
        }

        await axios.post(Config.API_URL, {
            query: `mutation getProrationAmount($data: JSON!) {
                      getProrationAmount(data: $data) {
                        data status message data
                      }
                    }`,
            variables: {
                data: data,
            }

        }, {
            headers: {
                accesstoken: auth_token ? auth_token : "",
                schemaname: "public",
                idToken: idToken ? idToken : ""
            }
        }).then(async (result:any) => {
            if(result.data.data.getProrationAmount.status === "true"){
                setdisplayProrateAmount(result.data.data.getProrationAmount.data.invoice.lines.data)
            }
            setisLoadingProrate(false)
        }).catch((error:any) => {
            if(error.response.status === 400 || error.response.status === 401){
              dispatch(setIsUserVerication(true))
            }
            dispatch(notificationFail({},error.message))
            setisLoadingProrate(false)
        });
    }

    const doProration = async () => {
        if(!loginUserData.customer_name){
            dispatch(notificationFail({},"Unable to get customer name of this user"));
            return
          }
          const obj = {
            customer_name:loginUserData.customer_name,
            display_name:loginUserData.customer_display_name,
            customer_id:loginUserData.customer_id,
          }
          departmentData.customers = obj
          dispatch(setLoading(true))

        //validate department as email
        if (!validateEmail(departmentData.department_name)) {
            dispatch(notificationFail({}, "Department name is not a valid email"))
            dispatch(setLoading(false))
            return
        }
        if (!selectedSubscription) {
            dispatch(notificationFail({}, "You don't have any active subscription."))
            dispatch(setLoading(false))
            return
        }

        const numberOfmemberTemp:any = numberOfmember

        if(!parseInt(numberOfmemberTemp) || parseInt(numberOfmemberTemp) < 0){
          dispatch(notificationFail({}, "Please enter user licenses more then zero"))
          dispatch(setLoading(false))
          return
        }

        const data = {
            selectedSubscription: selectedSubscription,
            department_data: departmentData,
            numberOfmember: numberOfmember,
        }

        await axios.post(Config.API_URL, {
            query: `mutation addProrate($data: JSON!) {
                      addProrate(data: $data) {
                        data status message data
                      }
                    }`,
            variables: {
                data: data,
            }
        }, {
            headers: {
                accesstoken: auth_token ? auth_token : "",
                schemaname: "public",
                idToken: idToken ? idToken : ""
            }
        }).then(async (result) => {
            if(result.data.data.addProrate.status === "true"){
              showSnackAlert(result.data.data.addProrate.message, 'success');
                const request = { username: loginUserData.username };
                dispatch(getBillingDetails(apolloClient.client, request));
                closeDialog()
                openCloseSuccessModal('memberAdd')
            }else{
              dispatch(notificationFail({},result.data.data.addProrate.message))
            }
            dispatch(setLoading(false))
        }).catch((error) => {
            if(error.response.status === 400 || error.response.status === 401){
              dispatch(setIsUserVerication(true))
            }
            dispatch(notificationFail({},error.message))
            dispatch(setLoading(false))
        });
    }

    const onChange = (event: any) => {
        if (event.target.name === "cardholderName") {
            setcardholderName(event.target.value);
        }

        if (event.target.name === "numberOfmember") {
            setnumberOfmember(event.target.value);
            getProrationAmount(event.target.value);
        }
    };

    const closeDialog = () => {
        closeModal()
        dispatch(setLoading(false))
    };

    const [IsUpdateCardDetail, setIsUpdateCardDetail] = useState(false);
    const changeCardDetail = () => {
        setIsUpdateCardDetail(true);
    };
    const closeCardDetailSection = () => {
        setIsUpdateCardDetail(false);
        setcardholderName('')
    };

    //update creadit card detail and set new payment method as default in stripe
    const updateCreditCard = async () => {
        if (!loginUserData.customer_name) {
            dispatch(notificationFail({}, "Unable to get customer name of this user"));
            return
        }
        const obj = {
            customer_name: loginUserData.customer_name,
            display_name: loginUserData.customer_display_name,
            customer_id: loginUserData.customer_id,
        }
        departmentData.customers = obj
        dispatch(setLoading(true))

        if (!cardholderName) {
            dispatch(notificationFail({}, "Please enter cardholder name."))
            dispatch(setLoading(false))
            return
        }
        await stripe.createPaymentMethod({
                type: 'card',
                card: elements.getElement(CardElement),
                billing_details: {
                    name: cardholderName,
                },
            })
            .then(async function(result: any) {
                if (result.error) {
                    dispatch(notificationFail({}, result.error.message))
                    dispatch(setLoading(false))
                    return
                }
                // Handle result.error or result.paymentMethod
                const updateCardReq = {
                    customer_id: departmentData.stripe_customer_id,
                    cardData: result.paymentMethod,
                    department_data: departmentData,
                }
                await axios.post(Config.API_URL, {
                    query: `mutation updateCreditCard($cardData: JSON!) {
                  updateCreditCard(cardData: $cardData) {
                    data status message data
                  }
                }`,
                    variables: {
                        cardData: updateCardReq,
                    }
                }, {
                    headers: {
                        accesstoken: auth_token ? auth_token : "",
                        schemaname: "public",
                        idToken: idToken ? idToken : ""
                    }
                }).then(async (result: any) => {
                    if (result.data.data.updateCreditCard.status === "true") {
                        showSnackAlert(result.data.data.updateCreditCard.message, 'success');
                        if (departmentData.stripe_customer_id) {
                            const req = { stripe_customer_id: departmentData.stripe_customer_id };
                            dispatch(getStripeCustomerDetail(apolloClient.client, req));
                        }
                        closeCardDetailSection()
                    } else {
                        dispatch(notificationFail({}, result.data.data.updateCreditCard.message))
                    }
                    dispatch(setLoading(false))
                }).catch((error: any) => {
                    if(error.response.status === 400 || error.response.status === 401){
                      dispatch(setIsUserVerication(true))
                    }
                    dispatch(notificationFail({}, error.message))
                    dispatch(setLoading(false))
                });

            }).catch((error: any) => {
                dispatch(notificationFail({}, error.message))
                dispatch(setLoading(false))
            });
    };

    return (
        <form>
      <CustomSnackBar type={snackAlertType} message={snackAlertMsg} open={isShownSnackAlert} onClose={hideSnackAlert} />
      <DialogContent className="customCardDesign">
        <Grid container style={{border:"1px solid #e4e4e4",borderRadius:"5px",boxShadow: '0 0px 2px 0 rgba(0, 0, 0, 0.2), 0 0px 0px 0 rgba(0, 0, 0, 0.19)'}}>
          <Grid item md={7}>
            <Box className={classes.cardDetails}>
              <Grid container>
                <Grid item md={6}>
                  <span className={classes.subdesc}>Subscription Tier</span>
                  <p className={classes.desc} style={{lineHeight:2}}>Immersion {selectedPlan.charAt(0).toUpperCase() + selectedPlan.slice(1)}</p>
                </Grid>
                <Grid item md={6}>
                  <span className={classes.subdesc}># of User Licenses Added</span>
                  <TextField
                    style={{width:'21%',margin: 0}}
                    value={numberOfmember}
                    type="number"
                    InputLabelProps={{
                      classes: {
                        root: classes.label,
                        focused: classes.focusedLabel,
                        error: classes.erroredLabel
                      },
                    }}
                    InputProps={{
                      classes: {
                        root: classes.underline,
                        error: classes.error
                      },
                      inputProps: { min: 1},
                      style:{
                        color: '#212D40',fontSize: '24px',fontFamily: 'Spartan-bold'
                      }
                    }}
                    inputProps={{
                      style:{
                        fontWeight:"bold",color:"black"
                      }
                    }}
                    size="small"
                    id="numberOfmember"
                    name="numberOfmember"
                    onChange={onChange}
                  />
                </Grid>

                {showCustomerDetails && stripeCustomerDetail.paymentMethods && stripeCustomerDetail.paymentMethods.length > 0 && !IsUpdateCardDetail &&
                  <>
                  <Grid item md={12} style={{marginTop:"52px"}} container>
                    <Grid item md={6}>
                    <span className={classes.subdesc}>Cardholder Name</span>
                    <span className={classes.cardholderName}>{stripeCustomerDetail.paymentMethods[0].billing_details.name}</span>
                    </Grid>
                    <Grid item md={6}>
                      <div style={{float:"right"}}>
                        <div className={classes.linkText} onClick={()=>changeCardDetail()}>Change Card Details</div>
                      </div>
                    </Grid>
                  </Grid>
                  <Grid item md={12} style={{marginTop:'30px'}}>
                  <div className="cardBox">
                    <Grid item md={6}>
                      <CreditCardTwoToneIcon  style={{fontSize:20,color:'#c1bcbc'}}/>
                      <span style={{fontWeight:'bold',color:"#606B76"}}>Saved Card</span>
                    </Grid>
                    <Grid item md={6}>
                      <span style={{fontWeight:'bold',color:"#606B76",float:"right"}}>**** **** **** {stripeCustomerDetail.paymentMethods[0].card.last4}</span>
                    </Grid>
                     
                  </div>
                  </Grid>
                  </>
                }

                {showCustomerDetails && stripeCustomerDetail.paymentMethods && stripeCustomerDetail.paymentMethods.length > 0 && IsUpdateCardDetail &&
                  <>
                    <Grid item md={12}>
                      <TextField
                        value={cardholderName}
                        InputLabelProps={{
                          classes: {
                            root: classes.label,
                            focused: classes.focusedLabel,
                            error: classes.erroredLabel
                          },
                        }}
                        InputProps={{
                          classes: {
                            root: classes.underline,
                            error: classes.error
                          }
                        }}
                        fullWidth
                        size="small"
                        id="cardholderName"
                        label="Cardholder Name"
                        name="cardholderName"
                        className={classes.cardName}
                        onChange={onChange}
                      />
                    </Grid>
                    <Grid item md={12} style={{marginTop:'30px'}}>
                      <CardElement /><br/>
                      <div style={{float:"right"}}>
                        <Button className={classes.cancelBtn} onClick={closeCardDetailSection}>
                          Cancel
                        </Button>
                          <Button  color='primary' className={classes.btn} onClick={updateCreditCard}>
                            {loading? <Loading style={{ width: 60, height: 30, marginTop: -20 }} />: 'Update'}
                          </Button>
                      </div>
                    </Grid>
                  </>
                }

              </Grid>
            </Box>
          </Grid>
          <Grid item md={5} className={classes.addLicenseModal}>
            {(isLoadingProrate)?
                <Loading style={{ width: 60, height: 30, marginTop: 80 }} />
                :
                (displayProrateAmount)
                    ?
                    <Box className={classes.billingDetails}>
                    <Grid container>
                        <Grid item md={12} className={classes.pricewrapper}>
                            <div className="totalAmt">
                                <strong>Total Charged Now</strong>
                                <p>{formatter.format((displayProrateAmount[0].amount+displayProrateAmount[1].amount)/100).replace(/\D00$/, '')}</p>
                            </div>
                            <br/>
                            <div className="perMonthUser">
                                <strong>${(selectedPlan=="clever")?199:(selectedPlan=="smart")?299:(selectedPlan=="genius")?499:"-"}</strong>
                                <p>PER USER / MONTH</p>
                                <p>FOR {remainingMonth?remainingMonth:"--"} MONTHS REMAINING ON SUBSCRIPTION</p>
                            </div>
                        </Grid>
                        <Grid item md={12} className={`subDate ${classes.priceDateWrapper}`}>
                          <strong className={classes.subdesc}>Subscription Through</strong>
                          <p className={classes.descDate}>{departmentData?UtilService.calculateNextDate(departmentData.pay_started_at, parseFloat(departmentData.billing_period)):"-"}</p>
                        </Grid>
                      </Grid>
                    </Box>
                    :
                    <Box className={classes.billingDetails}>
                    <Grid container>
                        <Grid item md={12} className={classes.pricewrapper}>
                          <div className="totalAmt">
                            <strong>Total Charged Now</strong>
                            <p>{selectedProduct && formatter.format((numberOfmember*selectedProduct.stripePrice)/100).replace(/\D00$/, '')}</p>
                          </div>
                          <div className="perMonthUser">
                            <strong>${(selectedPlan=="clever")?199:(selectedPlan=="smart")?299:(selectedPlan=="genius")?499:"-"}</strong>
                            <p>PER USER / MONTH</p>
                          </div>
                        </Grid>
                        <Grid item md={12} className={`subDate ${classes.priceDateWrapper}`}>
                          <span className={classes.subdesc}>Subscription Through</span>
                          {(departmentData && departmentData.stripe_subscription_id && departmentData.pay_started_at)?
                            <p className={classes.descDate}>{subscriptionDate?subscriptionDate:"-"}</p>
                            :
                              
                            <p className={classes.descDate}>{departmentData.pay_started_at ? moment(Number(departmentData.pay_started_at) * 1000).format("MM/DD/YYYY hh:mm ") : "-"}</p>
                          }
                        </Grid>
                      </Grid>
                    </Box>
            }
          </Grid>
        </Grid>
      </DialogContent>
      <Box mt={3} mb={3} mr={4} display='flex' justifyContent='flex-end'>
        {departmentData &&
          <>
            <Button variant="contained" className={classes.cancelBtn} onClick={closeDialog}>
              Cancel
            </Button>
            {!IsUpdateCardDetail && 
              <Button variant="contained" disabled={!stripe || isLoadingProrate} color='primary' className={classes.btn} onClick={makePayment}>
                {loading? <Loading style={{ width: 60, height: 30, marginTop: -20 }} />: 'Make Payment'}
              </Button>
            }
          </>
        }
      </Box>
    </form>
    );
};

function AddUserLicences({ open, onClose, departmentData, selectedPlan, openCloseSuccessModal,stripe_mode }: any) {
    const classes = useStyles();
    const dispatch = useDispatch();
    let stripePromise:any;
    if(stripe_mode === "TEST"){
        stripePromise = loadStripe(Config.stripePublishableKeyTest);
    }
    if(stripe_mode === "LIVE"){
        stripePromise = loadStripe(Config.stripePublishableKeyLive);
    }
    // close modal
    const closeModal = () => {
        onClose()
        dispatch(setLoading(false))
    };

    const children = <CheckoutForm closeModal={closeModal}  openCloseSuccessModal={openCloseSuccessModal} departmentData={departmentData} selectedPlan={selectedPlan}/>

    return (
        <Dialog
      disableEscapeKeyDown
      fullWidth={true}
      maxWidth={'md'}
      scroll='paper'
      open={open}
      classes={{
        root: classes.root,
        paper: classes.paper
      }}
    >
      <DialogTitle onClose={closeModal}>Add User License(s) to Subscription</DialogTitle>
      <Elements {...{children, stripe: stripePromise}} />
    </Dialog>
    );
}

export default AddUserLicences;